import { useMutation } from "react-query";

import { httpService } from "utils";
import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

export const useRemindPassword = () => {
  const { friendlyUrl } = useGetFriendlyUrl();
  return useMutation((data: FormData) => {
    return registerPassword(data, friendlyUrl);
  });
};

const registerPassword = (formData: FormData, friendlyUrl: string) => {
  return httpService().post(
    `/e-reservation/${friendlyUrl}/remind-password`,
    formData
  );
};
